{
  "moreActions": "Další akce",
  "unavailable": "Není k dispozici, rozbalením zobrazíte podrobnosti"
}
